import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  teamMemberViewLeaves,
  updateLeaderLeaveApplication,
  getMembers_Leader,
} from "../../http";
import Loading from "../Loading";

const TeamLeaveDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  // eslint-disable-next-line
  const { user } = useSelector((state) => state.authSlice);
  const [leaveDetails, setLeaveDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [leaderMessage, setLeaderMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const leaveRes = await teamMemberViewLeaves({ _id: id });
        if (leaveRes?.data) {
          setLeaveDetails(
            Array.isArray(leaveRes.data) ? leaveRes.data[0] : leaveRes.data
          );
        }

        const userRes = await getMembers_Leader();
        if (userRes.success) {
          setUsers(userRes.data);
        }
      } catch (err) {
        setError(`An error occurred: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleLeaveAction = async (action) => {
    try {
      setSubmitting(true);
      setError(null);
      setSuccess(null);

      const response = await updateLeaderLeaveApplication(id, {
        leaderResponse: action === "approve" ? "Approved" : "Rejected",
        leaderMessage,
      });

      if (response?.data?.success || response?.success) {
        setSuccess(
          `Leave application ${
            action === "approve" ? "approved" : "rejected"
          } successfully`
        );

        setLeaveDetails((prev) => ({
          ...prev,
          leaderResponse: action === "approve" ? "Approved" : "Rejected",
          leaderMessage,
        }));
      } else {
        setError("Failed to update leave application.");
      }
    } catch (err) {
      setError(`Error updating leave: ${err.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Loading />;
  if (error && !leaveDetails)
    return <div className="alert alert-danger">{error}</div>;

  return (
    <div className="main-content">
      <section className="section">
        <div className="section-header">
          <h1>Leave Application Details</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item">
              <div
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  history.push("/userLeaveApplications");
                }}>
                Leave Applications
              </div>
            </div>
            <div className="breadcrumb-item">Details</div>
          </div>
        </div>

        {success && <div className="alert alert-success">{success}</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>{leaveDetails?.title}</h4>
                  <span
                    className={`badge ml-2 ${
                      leaveDetails?.adminResponse === "Rejected"
                        ? "badge-danger"
                        : leaveDetails?.adminResponse === "Pending"
                        ? "badge-warning"
                        : "badge-success"
                    }`}>
                    {leaveDetails?.adminResponse}
                  </span>
                </div>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <h6>Applicant Information</h6>
                      <div>
                        <strong>Name:</strong>{" "}
                        {users.find(
                          (user) => user.id === leaveDetails?.applicantID
                        )?.name || "N/A"}
                      </div>
                      <div>
                        <strong>Email:</strong>{" "}
                        {users.find(
                          (user) => user.id === leaveDetails?.applicantID
                        )?.email || "N/A"}
                      </div>
                      {/* <div>
                        <strong>Department:</strong>{" "}
                        {users.find(
                          (user) => user.id === leaveDetails?.applicantID
                        )?.department || "N/A"}
                      </div> */}
                    </div>

                    <div className="col-md-6">
                      <h6>Leave Information</h6>
                      <div>
                        <strong>Type:</strong> {leaveDetails?.type}
                      </div>
                      <div>
                        <strong>Applied Date:</strong>{" "}
                        {leaveDetails?.appliedDate &&
                          new Date(leaveDetails.appliedDate)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}
                      </div>
                      <div>
                        <strong>Start Date:</strong>{" "}
                        {leaveDetails?.startDate &&
                          new Date(leaveDetails.startDate)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}
                      </div>
                      <div>
                        <strong>End Date:</strong>{" "}
                        {leaveDetails?.endDate &&
                          new Date(leaveDetails.endDate)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}
                      </div>
                      <div>
                        <strong>Period:</strong> {leaveDetails?.period}
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-12">
                      <h6>Leave Reason</h6>
                      <p>{leaveDetails?.reason || "No reason provided"}</p>
                    </div>
                  </div>

                  {leaveDetails?.leaderResponse && (
                    <div className="row mb-4">
                      <div className="col-12">
                        <h6>Leadership Response</h6>
                        <div>
                          <strong>Status:</strong> {leaveDetails.leaderResponse}
                        </div>
                        <div>
                          <strong>Message:</strong>{" "}
                          {leaveDetails.leaderMessage || "No message provided"}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label>Leadership Message</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          placeholder="Enter your message (optional)"
                          value={leaderMessage}
                          onChange={(e) => setLeaderMessage(e.target.value)}
                          disabled={submitting}></textarea>
                      </div>

                      <div className="buttons text-right">
                        <button
                          className="btn btn-success mr-2"
                          onClick={() => handleLeaveAction("approve")}
                          disabled={submitting}>
                          {submitting ? "Processing..." : "Approve Leave"}
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleLeaveAction("reject")}
                          disabled={submitting}>
                          {submitting ? "Processing..." : "Reject Leave"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                {/* End of Card Body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamLeaveDetails;
